<template>
  <div>
    <TitleButton />
    <user-map />
    <RadiusButton />
  </div>
</template>

<script>
import UserMap from "@/components/UserMap.vue"
import RadiusButton from "@/components/RadiusButton.vue"
import TitleButton from "@/components/TitleButton.vue"
export default {
  name: "DashboardPage",
  components: {
    TitleButton,
    RadiusButton,
    UserMap,
  },
  computed: {},
  methods: {},
}
</script>
